import { AbstractFilter } from './abstract-filter';

export class AutocompleteFilter extends AbstractFilter {

    public getValueFromChange(event, param) {
        return event ? event.id : null;
    }
}
